import React from 'react';
import { FormProps } from 'rsuite';
import { Form as FormikForm, useFormikContext } from 'formik';
import classNames from 'classnames';
import { Prompt } from '../Bicester';

/**
 * 只使用 RSuite <Form> 的样式，不使用它的功能
 */
export default function Form({
  guard = false,
  layout = 'vertical',
  fluid,
  className,
  style,
  children,
  'aria-busy': ariaBusy,
}: {
  guard?: boolean; // 是否需要表单离开拦截
} & FormProps) {
  const { dirty, isSubmitting } = useFormikContext();

  return (
    <>
      <FormikForm
        className={classNames(
          'rs-form',
          `rs-form-${layout}`,
          `rs-form-${fluid && layout === 'vertical' ? 'fluid' : 'fixed-width'}`,
          className
        )}
        style={style}
        aria-busy={ariaBusy}
      >
        {children}
      </FormikForm>
      {guard && <Prompt when={dirty && !isSubmitting} />}
    </>
  );
}
